import { RouteConfig } from 'vue-router';

export const updatePasswordRoute: RouteConfig = {
  path: '/update-password',
  name: 'updatePassword',
  component: () => import(/* webpackChunkName: "UpdatePassword" */ '@/views/startRoute/UpdatePassword.vue')
};
